var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        mouseenter: function ($event) {
          _vm.isHoveredInternal = true
        },
        mouseleave: function ($event) {
          _vm.isHoveredInternal = false
        },
      },
    },
    [
      _vm._t("default", null, {
        isHovered: _vm.isHovered,
        isTouch: _vm.isTouch,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }